var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{attrs:{"value":_vm.displayData,"color":_vm.color,"size":_vm.size ? _vm.size : '96',"width":_vm.width ? _vm.width : 8,"rotate":"270"}},[(!_vm.hasIcon)?_c('h1',{staticClass:"value",class:[
      _vm.iconColor ? _vm.iconColor : `${_vm.color}--text`,
      _vm.centerClass ? _vm.centerClass : '',
    ]},[_vm._v(" "+_vm._s(typeof _vm.value == "number" ? Math.ceil(_vm.value) : _vm.value)+" ")]):_c('h1',{staticClass:"value",class:`${_vm.iconColor ? _vm.iconColor : _vm.color}--text`},[_vm._t("centerIcon")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }